import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { AnalyticsTab } from "../config/analyticsTabs";

type TabDefinition = {
  value: AnalyticsTab;
  labelKey: string;
};

type AnalyticsTabsLayoutProps = {
  tabs: readonly TabDefinition[];
  activeTab: AnalyticsTab;
  onTabChange: (value: string) => void;
  renderPanel: (tab: AnalyticsTab) => React.ReactNode;
  filters?: React.ReactNode;
};

export const AnalyticsTabsLayout = ({
  tabs,
  activeTab,
  onTabChange,
  renderPanel,
  filters,
}: AnalyticsTabsLayoutProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <div className="flex w-full justify-center">
        <TabsList className="h-9 w-fit items-stretch rounded-lg bg-[#F4F2FB] p-1 text-foreground shadow-sm">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="flex items-center justify-center self-stretch rounded-md border border-transparent bg-transparent px-6 py-1 text-xs font-medium leading-none text-[#1F1F1F] shadow-none transition-colors hover:bg-[#EDE9FE]/40 data-[state=active]:border-[#CFC5FF] data-[state=active]:bg-[#ECE8FF] data-[state=active]:shadow-none"
            >
              {t(`analytics.${tab.labelKey}`, tab.labelKey)}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      <div className="mt-6 space-y-4">
        {filters}

        <TabsContent value={activeTab} className="mt-0">
          {renderPanel(activeTab)}
        </TabsContent>
      </div>
    </Tabs>
  );
};
